import React from "react";
import Fonts from "../../../../stories/assets/Fonts";
import Colors from "../../../../stories/assets/Colors";
import ModalSkeleton from "../../../ModalSkeleton/ModalSkeleton";
import { Button } from "../../../../stories/Button/Button";
import { Col, Modal, Row } from "react-bootstrap";
import classes from "./UserDetailModal.module.css";
import { coachDemoImg, starIconss } from "../../../../constant/imagePath";
import StarRatings from "react-star-ratings";
import moment from "moment";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";

const UserDetailModal = ({ show, setShow, data }) => {
  return (
    <>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        borderRadius={"20px"}
        width={"572px"}
        showCloseIcon={true}
      >
        <div className={classes.modalContent}>
          <Row className="g-0">
            <Col md={12} className="d-flex">
              <div>
                <img
                  src={data?.userData?.photo}
                  className={`${[classes.profile].join(" ")}`}
                />
              </div>
              <div className={classes.headingWithRatingAndReviews}>
                <h5 className={classes.mainHeading}>
                  <span
                    style={{ color: Colors.neutralShadesOfNero, ...Fonts.h4f26 }}
                  >
                    {data?.userData?.displayName?.split(" ")[0]}
                  </span>
                  <span
                    style={{ color: Colors.neutralShadesOfNero, ...Fonts.h4f26 }}
                  >
                    {data?.userData?.displayName?.split(" ")[1]}
                  </span>
                </h5>
                <div className={` ${[classes.userDetails].join(" ")}`}>
                  <p className={classes.ratingStar}>
                    <StarRatings
                      starRatedColor={Colors.mainShadeOfRed}
                      starEmptyColor={Colors.neutralShadesOfDimGray}
                      rating={data?.userData?.rating / 5}
                      starDimension={"16px"}
                      numberOfStars={1}
                    />
                  </p>
                  <span
                    className={`${[classes.rating].join(" ")}`}
                    style={{
                      color: Colors.neutralShadesOfNero,
                      ...Fonts.p2,
                      fontFamily: "inter-600",
                    }}
                  >
                    {data?.userData.rating?.toFixed(1)}
                  </span>

                  <span
                    className={`${[classes.break].join(" ")}`}
                    style={{
                      backgroundColor: Colors.neutralShadesOfPinkSwan,
                    }}
                  />

                  <span
                    style={{ color: Colors.neutralShadesOfNero, ...Fonts.h9 }}
                  >
                    {data?.userData.sport}
                  </span>
                  <span
                    className={`${[classes.break].join(" ")}`}
                    style={{
                      backgroundColor: Colors.neutralShadesOfPinkSwan,
                    }}
                  />

                  <span
                    style={{ color: Colors.neutralShadesOfNero, ...Fonts.h9 }}
                  >
                    Cancellation: {data?.userData.cancellation}
                  </span>
                </div>
              </div>
            </Col>
          </Row>

          {/* userDetailsCards start */}
          {data?.userDetailsCardsData?.map((item, index) => (
            <div className={classes.styledDivCard} key={index}>
              <h2 style={{ ...Fonts.h5 }}>{item.title}</h2>
              <p style={{ ...Fonts.p1 }} className={classes.marginBlock15}>
                {item.description}
              </p>
              <div className={classes.dFlex}>
                <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}>{item.timeAgo}</p>
                <span
                  className={`${[classes.break].join(" ")}`}
                  style={{
                    backgroundColor: Colors.neutralShadesOfPinkSwan,
                  }}
                />
                <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}>{moment(item.date).format("MMMM DD, YYYY")}</p>
              </div>
            </div>
          ))}

          {/* userDetailsCards end */}

          <div
            className={`${classes.modalButtons} ${classes.dFlexJustifyContentEnd}`}
          >
            <LinkButtonWithIcon
              primary={false}
              text="Cancel"
              customStyle={{ marginRight: 10, color: Colors.neutralShadesOfNero }}
              onClick={() => setShow(false)}
            />
            <Button
              size="Medium"
              label="Send warning email"
              style={{
                padding: "14px 16px",
                marginRight: 10,
                width: "max-content",
              }}
              onClick={() => setShow(false)}

            />
            <Button
              primary={true}
              size="Medium"
              label="Ban"
              style={{
                padding: "14px 24px",
                width: "max-content",
              }}
              onClick={() => setShow(false)}

            />
          </div>
          {/* </Modal.Footer> */}
        </div>
      </ModalSkeleton>
    </>
  );
};

export default UserDetailModal;

UserDetailModal.defaultProps = {
  data: {
    userData: {
      displayName: "Micheal Baumgardner",
      photo: coachDemoImg,
      rating: 5,
      sport: "Tennis coach",
      cancellation: "3",
    },
    userDetailsCardsData: [
      {
        title: "Plans have changed.",
        description:
          "Unfortunately, I am having problems of a family nature. Because of this, I will not be able to attend the training",
        timeAgo: "Within 24 hours",
        date: "Mon Jun 07 2021 05:00:00 GMT+0500 (Pakistan Standard Time)",
      },
      {
        title: "Medical emergency",
        description:
          "Yesterday I broke my arm and spent the day in the hospital, so I could not cancel the class in advance.",
        timeAgo: "Within 24 hours",
        date: "Mon Jun 07 2021 05:00:00 GMT+0500 (Pakistan Standard Time)",
      },
      {
        title: "Other",
        description: "",
        timeAgo: "Before 24 hours",
        date: "Mon Jun 07 2021 05:00:00 GMT+0500 (Pakistan Standard Time)",
      },
    ],
  },
};
